import { readLocalStorage, writeLocalStorage } from 'redux/saga/helpers/local-storage';
export var KEY_NAME_USE_TEST = 'cpUsePathToPurchaseTest';
export var KEY_NAME_ACTIVE_OFFER = 'cpActiveOfferId';
export var usePathToPurchaseTest = function usePathToPurchaseTest() {
  return readLocalStorage(KEY_NAME_USE_TEST, false);
};
export var setPathToPurchaseTest = function setPathToPurchaseTest() {
  var useTest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return writeLocalStorage(KEY_NAME_USE_TEST, useTest);
};
export var useActiveOfferId = function useActiveOfferId() {
  return readLocalStorage(KEY_NAME_ACTIVE_OFFER);
};
export var setActiveOfferId = function setActiveOfferId(id) {
  return writeLocalStorage(KEY_NAME_ACTIVE_OFFER, id);
};